var map = {
	"./agility-icon.png": 483,
	"./attack-icon.png": 484,
	"./construction-icon.png": 485,
	"./cooking-icon.png": 486,
	"./crafting-icon.png": 487,
	"./defense-icon.png": 488,
	"./farming-icon.png": 489,
	"./firemaking-icon.png": 490,
	"./fishing-icon.png": 491,
	"./fletching-icon.png": 492,
	"./herblore-icon.png": 493,
	"./hp-icon.png": 494,
	"./hunter-icon.png": 495,
	"./magic-icon.png": 496,
	"./mining-icon.png": 497,
	"./prayer-icon.png": 498,
	"./ranged-icon.png": 499,
	"./rparty-icon.png": 500,
	"./runecrafting-icon.png": 501,
	"./santa-icon.png": 502,
	"./skull-icon.png": 503,
	"./slayer-icon.png": 504,
	"./smithing-icon.png": 505,
	"./strength-icon.png": 506,
	"./thieving-icon.png": 507,
	"./woodcutting-icon.png": 508
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 181;



//////////////////
// WEBPACK FOOTER
// ./assets/icons ^\.\/.*\-icon\.png$
// module id = 181
// module chunks = 0